import React, {Component} from "react"
import PropTypes from "prop-types"
import styled, {css} from "styled-components"
import {connect} from "@irati/store"
import id from "@irati/utils/id"
import {injectIntl} from "@irati/utils/lang"
import {TextButton} from "@irati/ui/src/Button"
import {Body} from "@irati/ui/src/Typography"
import CompanyValues from "@irati-web/companyvalues/src/components/CompanyValuesList"

import {FeedItem} from "../../Feed"
import {FlexRow as FlexRowBase, BodyContainer as BodyContainerBase, RouterLink} from "../../shared"
import WhoCreated from "../../WhoCreated"
import ProfilePicGroup, {
  DEFAULT_OUTER_WRAPPER_SIZE,
  DEFAULT_SINGLE_PICTURE_SIZE,
  DEFAULT_MULTIPLE_PICTURE_SIZE
} from "../../ProfilePicGroup"
import {EndDate} from "../../Polls/ClosedPoll/styled/Card"
import ModeratedMessage from "../../shared/Moderated"
import VoteTitle from "./VoteTitle"
import {getPollPath} from "../../../utils/paths"

const FlexRow = styled(FlexRowBase)`
  ${({theme}) => css`
    align-items: start;
    margin-left: ${theme.spacing.two};
    ${theme.mediaQueries.minWidthMedia.tablet`
      margin-left: 0;
    `}
  `}
`

const BodyContainer = styled(BodyContainerBase)`
  ${({theme}) => css`
    margin-left: ${theme.spacing.one};
    ${theme.mediaQueries.minWidthMedia.tablet`
      margin-left: ${theme.spacing.two};
    `}
  `}
`

class FeedVote extends Component {
  static propTypes = {
    vote: PropTypes.object.isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    isMobile: PropTypes.bool.isRequired,
    intl: PropTypes.object.isRequired
  }

  static defaultProps = {
    className: null,
    id: "account-vote"
  }

  handleClick = () => {
    const {vote, onClick} = this.props
    onClick?.(vote)
  }

  getButtonProps = () => {
    return {
      inline: false,
      onClick: this.handleClick,
      id: id("btn", this.props)
    }
  }

  getLinkProps = () => {
    const {vote} = this.props
    return {
      to: getPollPath(vote.poll),
      scrollToTop: false,
      plain: true
    }
  }

  render() {
    const {className, onClick, vote, isMobile, intl} = this.props

    const outerWrapperSize = isMobile ? 80 : DEFAULT_OUTER_WRAPPER_SIZE
    const singlePictureSize = isMobile ? 70 : DEFAULT_SINGLE_PICTURE_SIZE
    const multiplePictureSize = isMobile ? 50 : DEFAULT_MULTIPLE_PICTURE_SIZE
    const Button = onClick ? TextButton : RouterLink
    const props = onClick ? this.getButtonProps() : this.getLinkProps()

    return (
      <Button {...props}>
        <FeedItem className={className}>
          <FlexRow>
            <ProfilePicGroup
              users={[vote.user]}
              outerWrapperSize={outerWrapperSize}
              singlePictureSize={singlePictureSize}
              multiplePictureSize={multiplePictureSize}
            />
            <BodyContainer>
              <VoteTitle vote={vote} />
              <CompanyValues companyValues={vote.companyValues} />
              <EndDate>{intl.formatRelative(vote.updatedAt)}</EndDate>
              <Body small marginBottom={1}>
                <ModeratedMessage message={vote.message} isModerated={vote.moderated} />
              </Body>
              <WhoCreated createdBy={vote.createdBy} />
            </BodyContainer>
          </FlexRow>
        </FeedItem>
      </Button>
    )
  }
}

const mapStateToProps = ({mq}) => {
  return {
    isMobile: mq.lessThan.md
  }
}

export default injectIntl(connect(mapStateToProps)(FeedVote))
